import { getConfig } from '@configs/envConfig'
import { HTTPRequestMethods } from '@enums/HTTPRequestMethods'
import { errorWithStack } from '@utils/logger'

const config = process.env.ACKO_ENV || 'prod'
const baseURL = `${getConfig(config)?.catalogServiceUrl}`

export const searchCars = async (query: string, cityName: string) => {
  try {
    const url = `${baseURL}/rest/v1/search?query=${encodeURIComponent(query)}&cityName=${encodeURIComponent(cityName)}`

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error fetching cars search:', error)
    return []
  }
}

export const searchBlogs = async (query: string) => {
  try {
    let url = `${baseURL}/rest/v1/search/articles`

    if (query?.trim()) {
      url += `?query=${encodeURIComponent(query)}`
    }

    const response = await fetch(url, {
      method: HTTPRequestMethods.GET,
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`API request failed: ${response.status}`)
    }

    const data = await response.json()
    return data
  } catch (error) {
    errorWithStack('Error searching blogs:', error)
    return []
  }
}
